import {
  Component,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit,
  Input,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { Location } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AddRiskComponent } from './add-risk/add-risk.component';
import { DialogAnimationsExampleDialog } from '@/app/components/projects/project-stages/plan-sections/custom-generated/manual-generated/manual-generated.component';
import { DocumentService } from '@/app/services/shared/document.service';
import { TabbedScrollerComponent } from '../../tabbed-scroller/tabbed-scroller.component';
import { ProjectWrapperComponent } from '../../project-wrapper/project-wrapper.component';
import { ProjectStageApprovalComponent } from '../../project-stage-approval/project-stage-approval.component';
import { SendForApprovalComponent } from '@/app/components/global/dialog-boxes/send-for-approval/send-for-approval.component';
import { NgToastService } from 'ng-angular-popup';
import { PROJECT_STAGE } from '@/app/enums/project_stages.enum';
import { ReloadPlanDataService } from '@/app/services/shared/reload-plan-data.service';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
import { ProgressService } from '@/app/services/shared/progress.service';
enum VIEW_MODES {
  RISK_ADD = 1,
  RISK_REGISTER = 0,
}

interface ApprovalDetail {
  feedback: string | null;
  status: string;
  userName: string;
  userTitle: string | null;
  parentStatus: string;
}

@Component({
  selector: 'app-risk-assessment',
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    MatDialogModule,
    AddRiskComponent,
    DialogAnimationsExampleDialog,
    ProjectStageApprovalComponent,
    ProgressBarComponent,
  ],
  templateUrl: './risk-assessment.component.html',
  styleUrl: './risk-assessment.component.css',
})
export class RiskAssessmentComponent implements OnInit {
  @ViewChild('addRisk') addRiskDialog!: TemplateRef<any>;
  @ViewChild('riskRegisterContainer') riskRegisterContainer!: ElementRef;

  readonly dialog = inject(MatDialog);

  @Input() progress: number = 0;
  PROJECT_STAGE = PROJECT_STAGE;
  riskCategories = [];
  allRiskData: any;
  VIEW_MODES = VIEW_MODES;
  mode: VIEW_MODES = VIEW_MODES.RISK_REGISTER;
  isStageTwoSendForApproval: boolean = false;
  approvalDetails: ApprovalDetail[] = [];
  isStageTwoCompleted: boolean = false;
  selectedSection = 'section1';
  stage2Progress: any;
  constructor(
    private router: Router,
    private location: Location,
    private projectsService: ProjectsService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private documentService: DocumentService,
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private projectWrapperComponent: ProjectWrapperComponent,
    private toast: NgToastService,
    private reloadPlanDataService: ReloadPlanDataService,
    private dialogService: DialogUtilityService,
    private progressService: ProgressService
  ) {} // Inject Location service

  ngOnInit() {
    this.getRiskCategories();
    this.getStageTwoApproversDetails();
    this.checkStageTwoApproval();
    this.progressService.progress2$.subscribe((value) => {
      this.stage2Progress = value;
    });
  }

  getAllRisk() {
    this.projectsService.viewRisk().subscribe({
      next: (response: any) => {
        if (response?.data && this.riskCategories?.length > 0) {
          this.allRiskData = response.data;
          this.documentService.setDocumentData(response.data.length, 'Risks');
          this.riskCategories.forEach((category) => {
            this.allRiskData.forEach((risk) => {
              if (risk.risk_category_id === category.id) {
                risk.risk_category = category.name;
              }
            });
          });
        }

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('Error while fetching risk assessment data:', error);
      },
    });
  }

  getRiskCategories() {
    this.projectsService.getRiskCategories().subscribe({
      next: (response) => {
        if (response) {
          this.riskCategories = response?.data;
          if (response?.data) {
            this.getAllRisk();
          }
        }
      },
      error: (error) => {
        if (error) {
          console.log(error);
        }
      },
    });
  }

  handleProjectStage2Approval() {
    // if (!this.isStageTwoCompleted) {
    //   this.toast.warning('Project Plan is incomplete!', 'WARNING', 4000);
    //   return
    // }

    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      this.toast.danger('Project id not found', 'ERROR');
      return;
    }
    const dialogRef = this.dialog.open(SendForApprovalComponent, {
      // Sending props
      width:'80vw',
      data: {
        progress: this.progress,
        stage: PROJECT_STAGE?.STAGE_2,
        projectId: projectId,
        approvalResponses: this.approvalDetails,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.toast.success('Approval sent successfully!', 'SUCCESS', 4000);
        this.checkStageTwoApproval();
      }
    });
  }

  getStageTwoApproversDetails(): Promise<void> {
    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      return;
    }

    this.projectsService
      .fetchCurrentStageApprovalPercentage(projectId, 2)
      .subscribe({
        next: (response) => {
          if (response.meta.success) {
            this.isStageTwoCompleted = response.data == 100 ? true : false;
          }
        },
        error: (error) => {
          console.error('Error while fetching project percentage:', error);
        },
      });
  }

  // this fetches approvers data not approval
  async checkStageTwoApproval(): Promise<void> {
    /**
     * send request to check if approval for stage 1 exists.
     * show component sendforapproval/project-stage-approval based on the result
     */
    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      return;
    }

    const data = {
      project_id: projectId,
      stage: PROJECT_STAGE?.STAGE_2,
    };

    try {
      const temp = await this.projectsService
        .getCurrentStageApproval(data)
        .toPromise();

      if (temp.data.length > 0) {
        this.approvalDetails = temp?.data?.map((item: any) => ({
          feedback: item.feedback,
          status: item.status,
          userName: item.user.name,
          userTitle: item.user.title,
          parentStatus: item?.parent_status,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  getSanitizedHtml(description: string) {
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  navigatetoPreviousPage() {
    this.location.back();
  }

  showAddRiskDialog(): void {
    this.mode = VIEW_MODES.RISK_ADD;
  }

  closeAddRisk(): void {
    this.mode = VIEW_MODES.RISK_REGISTER;
  }

  onChangeToRiskRegister($event: boolean) {
    if ($event) {
      this.mode = VIEW_MODES.RISK_REGISTER;

      if (this.mode === VIEW_MODES.RISK_REGISTER) {
        this.scrollToSection('section-project-riskassessment');
        this.getAllRisk();
      }
    }
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    const header = document.querySelector('.sticky-tab-panel') as HTMLElement; // Get the sticky header element
    const headerHeight = header ? header.offsetHeight : 0; // Get the height of the header

    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY; // Get the absolute position of the element
      const offsetPosition = elementPosition - headerHeight; // Calculate the position minus the header height

      // Smoothly scroll to the calculated position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth', // Add smooth scrolling
      });
    }
  }
  handleBack() {
    this.TabbedScrollerComponent.previousStep();
  }
  closeDialog() {
    this.dialogService.closeProjectPlanDialog();
  }
}
